module.exports = ".local-ng {\n    background: #ccc;\n    margin: 10px 0;\n}\n    .local-ng:hover {\n        cursor : pointer;\n    }\n    .local-img {\n    display: inline-block;\n    vertical-align: top;\n}\n    .local-content {\n    display: inline-block;\n    vertical-align: top;\n    \n    padding: 10px;\n}\n    .card-annuaire .card-annuaire-body img {\n\tmargin-bottom: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/locaux/listing-locaux/listing-locaux.component.css
// module id = ./src/app/locaux/listing-locaux/listing-locaux.component.css
// module chunks = main